import {PlatformNavbarMenuItem} from "@flexinet/ui-components";


import {
    AiOutlineAim,
    AiOutlineBarChart,
    AiOutlineDelete,
    AiOutlineInbox,
    AiOutlineMail,
    AiOutlineRead,
    AiOutlineSend,
    AiOutlineSetting,
    AiOutlineTag,
    AiOutlineUser,
    AiOutlineTool
} from 'react-icons/ai'
import {MdArchive} from 'react-icons/md';
import {rbacActions} from "../../../config/rbac/actions.ts";

const ICON_SIZE = '1.5em'

export const getMenuItems = () => {

    return [
        {
            id: 'messages',
            link: '/messages',
            label: 'Email Messages',
            icon: <AiOutlineMail size={ICON_SIZE}/>,
            rbac: rbacActions.ListMessages,
            defaultOpened: true,
            links: [{
                id: 'all',
                link: '/messages/status/inbox',
                label: 'Inbox',
                icon: <AiOutlineInbox size={ICON_SIZE}/>,
                rbac: rbacActions.ListMessages,
            }, {
                id: 'read',
                link: '/messages/status/read',
                label: 'Read',
                icon: <AiOutlineRead size={ICON_SIZE}/>,
                rbac: rbacActions.ListMessages,
            }, {
                id: 'sent',
                link: '/messages/status/sent',
                label: 'Sent',
                icon: <AiOutlineSend size={ICON_SIZE}/>,
                rbac: rbacActions.ListMessages,
            }, {
                id: 'archived',
                link: '/messages/status/archived',
                label: 'Archived',
                icon: <MdArchive size={ICON_SIZE}/>,
                rbac: rbacActions.ListMessages,
            }, {
                id: 'deleted',
                link: '/messages/status/deleted',
                label: 'Deleted',
                icon: <AiOutlineDelete size={ICON_SIZE}/>,
                rbac: rbacActions.ListMessages,
            }],
        }, {
            id: 'tags-group',
            link: '#',
            label: 'Tags',
            icon: <AiOutlineTag size={ICON_SIZE}/>,
            rbac: rbacActions.ListTags,
            defaultOpened: true,
            links: [],
        }, {
            id: 'analytics',
            link: '/analytics',
            label: 'Analytics',
            icon: <AiOutlineBarChart size={ICON_SIZE}/>,
            rbac: rbacActions.GetAnalytics,
        }, {
            id: 'account-settings',
            link: '/account-settings',
            label: 'Account Settings',
            icon: <AiOutlineSetting size={ICON_SIZE}/>,
            defaultOpened: true,
            rbac: rbacActions.GetAccountSettings,
            links: [{
                id: 'aliases',
                link: '/aliases',
                label: 'Aliases',
                icon: <AiOutlineAim size={ICON_SIZE}/>,
                rbac: rbacActions.ListAliases,
            }, {
                id: 'personas',
                link: '/personas',
                label: 'Personas',
                icon: <AiOutlineUser size={ICON_SIZE}/>,
                rbac: rbacActions.ListPersonas,
            }, {
                id: 'tags',
                link: '/tags',
                label: 'Tags',
                icon: <AiOutlineTag size={ICON_SIZE}/>,
                rbac: rbacActions.ListTags,
            }],
        }, {
            id: 'contacts',
            link: '/contacts',
            label: 'Contacts',
            icon: <AiOutlineUser size={ICON_SIZE}/>,
            rbac: rbacActions.ListContacts,
        }, {
            id: 'administration',
            link: '/administration',
            label: 'Administration',
            icon: <AiOutlineTool size={ICON_SIZE}/>,
            rbac: rbacActions.GetAdministration,
        }] as PlatformNavbarMenuItem[];

};

